import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { HubOverview } from '../models';
import { HubEndpoint } from '../constants/hub-endpoint';
import { API_URL } from '../../../../../services/config';

@Injectable({
  providedIn: 'root',
})
export class HubItemService {
  constructor(private http: WrapperHttpService) {}

  createNewHub(body: HubOverview): Observable<HubOverview> {
    return this.http.withLoading().post<HubOverview>(`${API_URL}${HubEndpoint.Base}`, body);
  }

  changeHubActiveState(hubId: number, enable: boolean): Observable<void> {
    return this.http
      .withLoading()
      .post<void>(`${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.Enable}`, { enable });
  }

  deleteHub(hubId: number): Observable<void> {
    return this.http.withLoading().delete<void>(`${API_URL}${HubEndpoint.Base}/${hubId}`);
  }

  getNewSsccId(): Observable<number> {
    return this.http.withLoading().get<number>(`${API_URL}${HubEndpoint.Base}${HubEndpoint.SsccId}`, {
      responseType: 'text',
    });
  }
}
